<template>
    <b-modal
        id="unsubscribed-students"
        v-model="modal"
        title="Leerlingen die voor deze periode nog geen module gekozen hebben"
        :ok-title="$t('common.close')"
        modal-class="apprentice-default-modal"
        ok-only>
        <design-2021-apprentice-data-table
            class="period-modules-overview-table"
            :items="unsubscribedStudentsIn"
            :fields="fields"
            :show-empty="true">
        </design-2021-apprentice-data-table>
    </b-modal>
</template>

<script>
import Design2021ApprenticeDataTable from '../../common/design-2021-apprentice-data-table.vue';

export default {
    name: 'design-2021-module-unsubscribed-students-modal-component',
    components: { Design2021ApprenticeDataTable },
    props: {
        unsubscribedStudentsIn: {
            type: Array,
            required: true,
        },
    },
    data() {
        return {
            fields: [
                {
                    key: 'full_name',
                    label: 'Leerling',
                },
            ],
            modal: false,
        };
    },
    methods: {
        show() {
            this.modal = true;
        },
    },
};
</script>

<style scoped lang="scss"></style>
